import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { sendNotification } from "../api/plan";
import { generateTokenByApiKey } from "../api/login";
import { SHOW_SNACKBAR } from "../utils/types";
import { getEmailBody } from "../utils/helper";

const Career = () => {
  const [notification, setNotification] = useState({});
  let dispatch = useDispatch();

  const onSendEmail = (e) => {
    e.preventDefault();
    const { name, email, phone, message } = notification;
    const emailBody = getEmailBody(name, email, phone, message);
    const request = {
      notificationType: "EMAIL",
      from: process.env.REACT_APP_SENDER_EMAIL,
      subject: "Became Agent Request",
      toUsers: {
        [process.env.REACT_APP_TO_EMAIL]: {
          email: process.env.REACT_APP_TO_EMAIL
        }
      },
      body: emailBody
    };
    dispatch(
      generateTokenByApiKey(
        {},
        "zealthix",
        {
          "x-tenant-id": process.env.REACT_APP_TENANT_ID,
          "X-Api-Key": process.env.REACT_APP_API_KEY,
          "Content-Type": "application/json",
        },
        (t) => {
          if (t.access_token) {
            dispatch(sendNotification(request, t.access_token, a => {
              e.target.reset();
              setNotification({});
              dispatch({
                type: SHOW_SNACKBAR,
                payload: {
                  type: "error",
                  message: "Email sent successfully",
                  open: true,
                },
              });
            }))
          }
        }
      )
    );
  }
  return (
    <>
      <section className="pt-[180px] max-md:pt-[130px] pb-[80px] relative max-lg:bg-[right_center] bg-[#f4f4f4] about-banner overflow-hidden">
        <div className="container">
          <div className="row items-center">
            <div className="w-full">
              <div className="relative max-md:text-center">
                <h2 className="text-[92px] max-md:text-[50px] font-bold capitalize font-sora text-secondary leading-[1.2]">
                  Join Our Team
                </h2>
                <img
                  src="assets/img/shap-three-1.png"
                  alt="banner-shap"
                  className="absolute w-46 w-35 -top-[30px] -left-[32px] max-md:hidden  animate-topshap"
                />
              </div>
              <ol className="mb-[16px] flex items-center max-md:justify-center max-md:mb-[40px] pt-[20px] max-md:hidden">
                <li className="text-[22px] text-secondary font-sora capitalize">
                  <Link to="/"> Home </Link>
                </li>
                <li
                  className="text-[22px] text-gary capitalize before:content-['-'] before:float-left before:text-gary before:px-[10px]"
                  aria-current="page"
                >
                  Career
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section id="h4-pricing" className="relative w-full overflow-hidden">
        <div className="w-full h4-pricing-wrapper max-md:px-[30px] pb-[80px] md:pb-[80px] max-md:pt-[60px] md:pt-[80px] pricing_section_bg">
          <div className="theme-container mx-auto">
            <div className="w-full">
              <div className="container">
                <div className="services-details-items">

                  <div className="bg-white relative lg:py-20">
                    <div
                      className="flex flex-col items-center justify-between mt-0 mr-auto mb-0 ml-auto lg:flex-row"
                    >
                      <div className="flex flex-col items-center w-full lg:flex-row">
                        <div className="w-full bg-cover relative max-w-md lg:max-w-2xl lg:w-7/12">
                          <div className="flex flex-col items-center justify-center w-full h-full relative lg:pr-10">
                            <img
                              src="assets/img/career.png"
                              className="btn-"
                            />
                          </div>
                        </div>
                        <div className="w-full mt-20 mr-0 mb-0 ml-0 relative z-10 max-w-2xl lg:mt-0 lg:w-5/12">
                          <div
                            className="flex flex-col items-start justify-start pt-10 pr-10 pb-10 pl-10 bg-white shadow-2xl rounded-xl
      relative z-10"
                          >
                            <p className="w-full text-4xl font-medium text-center leading-snug font-serif">
                              Join Our Team
                            </p>
                            <p className="text-[14px] text-center mb-5">
                              Partner with us as an agent to help users access and book healthcare services—while earning attractive incentives. Simple, flexible, and built for your growth.
                            </p>
                            <form onSubmit={onSendEmail} action="#" className="w-full mt-6 mr-0 mb-0 ml-0 relative space-y-8">
                              <div className="relative">
                                <p
                                  className="bg-white pt-0 pr-2 pb-0 pl-2 -mt-3 mr-0 mb-0 ml-2 font-medium text-gray-600
                                  absolute">Full Name
                                </p>
                                <input
                                  value={notification?.name} required onChange={(e) =>
                                    setNotification({ ...notification, name: e.target.value })
                                  }
                                  placeholder="John"
                                  type="text"
                                  className="border placeholder-gray-400 focus:outline-none
            focus:border-black w-full pt-4 pr-4 pb-4 pl-4 mt-2 mr-0 mb-0 ml-0 text-base block bg-white
            border-gray-300 rounded-md"
                                />
                              </div>
                              <div className="relative">
                                <p className="bg-white pt-0 pr-2 pb-0 pl-2 -mt-3 mr-0 mb-0 ml-2 font-medium text-gray-600 absolute">
                                  Email
                                </p>
                                <input
                                  value={notification?.email} required onChange={(e) =>
                                    setNotification({ ...notification, email: e.target.value })
                                  }
                                  placeholder="email@gmail.com"
                                  type="text"
                                  className="border placeholder-gray-400 focus:outline-none
            focus:border-black w-full pt-4 pr-4 pb-4 pl-4 mt-2 mr-0 mb-0 ml-0 text-base block bg-white
            border-gray-300 rounded-md"
                                />
                              </div>
                              <div className="relative">
                                <p className="bg-white pt-0 pr-2 pb-0 pl-2 -mt-3 mr-0 mb-0 ml-2 font-medium text-gray-600 absolute">
                                  Phone Number
                                </p>
                                <input
                                  value={notification?.phone} required onChange={(e) =>
                                    setNotification({ ...notification, phone: e.target.value })
                                  }
                                  placeholder="+91 123 456 7800"
                                  type="text"
                                  className="border placeholder-gray-400 focus:outline-none
            focus:border-black w-full pt-4 pr-4 pb-4 pl-4 mt-2 mr-0 mb-0 ml-0 text-base block bg-white
            border-gray-300 rounded-md"
                                />
                              </div>
                              <div className="relative">
                                <p className="bg-white pt-0 pr-2 pb-0 pl-2 -mt-3 mr-0 mb-0 ml-2 font-medium text-gray-600 absolute">
                                  Message
                                </p>
                                <textarea
                                  value={notification?.message || ""} required onChange={(e) =>
                                    setNotification({ ...notification, message: e.target.value })
                                  }
                                  placeholder="Write Something..."
                                  type="text"
                                  className="resize-none border placeholder-gray-400 focus:outline-none
            focus:border-black w-full pt-4 pr-4 pb-4 pl-4 mt-2 mr-0 mb-0 ml-0 text-base block bg-white
            border-gray-300 rounded-md"
                                />
                              </div>
                              <div className="relative">
                                <button
                                  className="w-full inline-block pt-4 pr-5 pb-4 pl-5 text-xl font-medium text-center text-white bg-[#1F87C9]
            rounded-lg transition duration-200 hover:bg-[#021935] ease"
                                >
                                  Submit
                                </button>
                              </div>
                            </form>
                          </div>
                          <svg
                            viewBox="0 0 91 91"
                            className="absolute top-0 left-0 z-0 w-32 h-32 -mt-12 -ml-12 text-yellow-300
      fill-current"
                          >
                            <g stroke="none" strokewidth={1} fillrule="evenodd">
                              <g fillrule="nonzero">
                                <g>
                                  <g>
                                    <circle cx="3.261" cy="3.445" r="2.72" />
                                    <circle cx="15.296" cy="3.445" r="2.719" />
                                    <circle cx="27.333" cy="3.445" r="2.72" />
                                    <circle cx="39.369" cy="3.445" r="2.72" />
                                    <circle cx="51.405" cy="3.445" r="2.72" />
                                    <circle cx="63.441" cy="3.445" r="2.72" />
                                    <circle cx="75.479" cy="3.445" r="2.72" />
                                    <circle cx="87.514" cy="3.445" r="2.719" />
                                  </g>
                                  <g transform="translate(0 12)">
                                    <circle cx="3.261" cy="3.525" r="2.72" />
                                    <circle cx="15.296" cy="3.525" r="2.719" />
                                    <circle cx="27.333" cy="3.525" r="2.72" />
                                    <circle cx="39.369" cy="3.525" r="2.72" />
                                    <circle cx="51.405" cy="3.525" r="2.72" />
                                    <circle cx="63.441" cy="3.525" r="2.72" />
                                    <circle cx="75.479" cy="3.525" r="2.72" />
                                    <circle cx="87.514" cy="3.525" r="2.719" />
                                  </g>
                                  <g transform="translate(0 24)">
                                    <circle cx="3.261" cy="3.605" r="2.72" />
                                    <circle cx="15.296" cy="3.605" r="2.719" />
                                    <circle cx="27.333" cy="3.605" r="2.72" />
                                    <circle cx="39.369" cy="3.605" r="2.72" />
                                    <circle cx="51.405" cy="3.605" r="2.72" />
                                    <circle cx="63.441" cy="3.605" r="2.72" />
                                    <circle cx="75.479" cy="3.605" r="2.72" />
                                    <circle cx="87.514" cy="3.605" r="2.719" />
                                  </g>
                                  <g transform="translate(0 36)">
                                    <circle cx="3.261" cy="3.686" r="2.72" />
                                    <circle cx="15.296" cy="3.686" r="2.719" />
                                    <circle cx="27.333" cy="3.686" r="2.72" />
                                    <circle cx="39.369" cy="3.686" r="2.72" />
                                    <circle cx="51.405" cy="3.686" r="2.72" />
                                    <circle cx="63.441" cy="3.686" r="2.72" />
                                    <circle cx="75.479" cy="3.686" r="2.72" />
                                    <circle cx="87.514" cy="3.686" r="2.719" />
                                  </g>
                                  <g transform="translate(0 49)">
                                    <circle cx="3.261" cy="2.767" r="2.72" />
                                    <circle cx="15.296" cy="2.767" r="2.719" />
                                    <circle cx="27.333" cy="2.767" r="2.72" />
                                    <circle cx="39.369" cy="2.767" r="2.72" />
                                    <circle cx="51.405" cy="2.767" r="2.72" />
                                    <circle cx="63.441" cy="2.767" r="2.72" />
                                    <circle cx="75.479" cy="2.767" r="2.72" />
                                    <circle cx="87.514" cy="2.767" r="2.719" />
                                  </g>
                                  <g transform="translate(0 61)">
                                    <circle cx="3.261" cy="2.846" r="2.72" />
                                    <circle cx="15.296" cy="2.846" r="2.719" />
                                    <circle cx="27.333" cy="2.846" r="2.72" />
                                    <circle cx="39.369" cy="2.846" r="2.72" />
                                    <circle cx="51.405" cy="2.846" r="2.72" />
                                    <circle cx="63.441" cy="2.846" r="2.72" />
                                    <circle cx="75.479" cy="2.846" r="2.72" />
                                    <circle cx="87.514" cy="2.846" r="2.719" />
                                  </g>
                                  <g transform="translate(0 73)">
                                    <circle cx="3.261" cy="2.926" r="2.72" />
                                    <circle cx="15.296" cy="2.926" r="2.719" />
                                    <circle cx="27.333" cy="2.926" r="2.72" />
                                    <circle cx="39.369" cy="2.926" r="2.72" />
                                    <circle cx="51.405" cy="2.926" r="2.72" />
                                    <circle cx="63.441" cy="2.926" r="2.72" />
                                    <circle cx="75.479" cy="2.926" r="2.72" />
                                    <circle cx="87.514" cy="2.926" r="2.719" />
                                  </g>
                                  <g transform="translate(0 85)">
                                    <circle cx="3.261" cy="3.006" r="2.72" />
                                    <circle cx="15.296" cy="3.006" r="2.719" />
                                    <circle cx="27.333" cy="3.006" r="2.72" />
                                    <circle cx="39.369" cy="3.006" r="2.72" />
                                    <circle cx="51.405" cy="3.006" r="2.72" />
                                    <circle cx="63.441" cy="3.006" r="2.72" />
                                    <circle cx="75.479" cy="3.006" r="2.72" />
                                    <circle cx="87.514" cy="3.006" r="2.719" />
                                  </g>
                                </g>
                              </g>
                            </g>
                          </svg>
                          <svg
                            viewBox="0 0 91 91"
                            className="absolute bottom-0 right-0 z-0 w-32 h-32 -mb-12 -mr-12 text-indigo-500
      fill-current"
                          >
                            <g stroke="none" strokewidth={1} fillrule="evenodd">
                              <g fillrule="nonzero">
                                <g>
                                  <g>
                                    <circle cx="3.261" cy="3.445" r="2.72" />
                                    <circle cx="15.296" cy="3.445" r="2.719" />
                                    <circle cx="27.333" cy="3.445" r="2.72" />
                                    <circle cx="39.369" cy="3.445" r="2.72" />
                                    <circle cx="51.405" cy="3.445" r="2.72" />
                                    <circle cx="63.441" cy="3.445" r="2.72" />
                                    <circle cx="75.479" cy="3.445" r="2.72" />
                                    <circle cx="87.514" cy="3.445" r="2.719" />
                                  </g>
                                  <g transform="translate(0 12)">
                                    <circle cx="3.261" cy="3.525" r="2.72" />
                                    <circle cx="15.296" cy="3.525" r="2.719" />
                                    <circle cx="27.333" cy="3.525" r="2.72" />
                                    <circle cx="39.369" cy="3.525" r="2.72" />
                                    <circle cx="51.405" cy="3.525" r="2.72" />
                                    <circle cx="63.441" cy="3.525" r="2.72" />
                                    <circle cx="75.479" cy="3.525" r="2.72" />
                                    <circle cx="87.514" cy="3.525" r="2.719" />
                                  </g>
                                  <g transform="translate(0 24)">
                                    <circle cx="3.261" cy="3.605" r="2.72" />
                                    <circle cx="15.296" cy="3.605" r="2.719" />
                                    <circle cx="27.333" cy="3.605" r="2.72" />
                                    <circle cx="39.369" cy="3.605" r="2.72" />
                                    <circle cx="51.405" cy="3.605" r="2.72" />
                                    <circle cx="63.441" cy="3.605" r="2.72" />
                                    <circle cx="75.479" cy="3.605" r="2.72" />
                                    <circle cx="87.514" cy="3.605" r="2.719" />
                                  </g>
                                  <g transform="translate(0 36)">
                                    <circle cx="3.261" cy="3.686" r="2.72" />
                                    <circle cx="15.296" cy="3.686" r="2.719" />
                                    <circle cx="27.333" cy="3.686" r="2.72" />
                                    <circle cx="39.369" cy="3.686" r="2.72" />
                                    <circle cx="51.405" cy="3.686" r="2.72" />
                                    <circle cx="63.441" cy="3.686" r="2.72" />
                                    <circle cx="75.479" cy="3.686" r="2.72" />
                                    <circle cx="87.514" cy="3.686" r="2.719" />
                                  </g>
                                  <g transform="translate(0 49)">
                                    <circle cx="3.261" cy="2.767" r="2.72" />
                                    <circle cx="15.296" cy="2.767" r="2.719" />
                                    <circle cx="27.333" cy="2.767" r="2.72" />
                                    <circle cx="39.369" cy="2.767" r="2.72" />
                                    <circle cx="51.405" cy="2.767" r="2.72" />
                                    <circle cx="63.441" cy="2.767" r="2.72" />
                                    <circle cx="75.479" cy="2.767" r="2.72" />
                                    <circle cx="87.514" cy="2.767" r="2.719" />
                                  </g>
                                  <g transform="translate(0 61)">
                                    <circle cx="3.261" cy="2.846" r="2.72" />
                                    <circle cx="15.296" cy="2.846" r="2.719" />
                                    <circle cx="27.333" cy="2.846" r="2.72" />
                                    <circle cx="39.369" cy="2.846" r="2.72" />
                                    <circle cx="51.405" cy="2.846" r="2.72" />
                                    <circle cx="63.441" cy="2.846" r="2.72" />
                                    <circle cx="75.479" cy="2.846" r="2.72" />
                                    <circle cx="87.514" cy="2.846" r="2.719" />
                                  </g>
                                  <g transform="translate(0 73)">
                                    <circle cx="3.261" cy="2.926" r="2.72" />
                                    <circle cx="15.296" cy="2.926" r="2.719" />
                                    <circle cx="27.333" cy="2.926" r="2.72" />
                                    <circle cx="39.369" cy="2.926" r="2.72" />
                                    <circle cx="51.405" cy="2.926" r="2.72" />
                                    <circle cx="63.441" cy="2.926" r="2.72" />
                                    <circle cx="75.479" cy="2.926" r="2.72" />
                                    <circle cx="87.514" cy="2.926" r="2.719" />
                                  </g>
                                  <g transform="translate(0 85)">
                                    <circle cx="3.261" cy="3.006" r="2.72" />
                                    <circle cx="15.296" cy="3.006" r="2.719" />
                                    <circle cx="27.333" cy="3.006" r="2.72" />
                                    <circle cx="39.369" cy="3.006" r="2.72" />
                                    <circle cx="51.405" cy="3.006" r="2.72" />
                                    <circle cx="63.441" cy="3.006" r="2.72" />
                                    <circle cx="75.479" cy="3.006" r="2.72" />
                                    <circle cx="87.514" cy="3.006" r="2.719" />
                                  </g>
                                </g>
                              </g>
                            </g>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="shape-1 absolute left-40 top-96 z-10">
            <img src="assets/images/home-four/shape-1.webp" alt="" />
          </div>
          <div className="shape-2 absolute right-96 top-96 z-10">
            <img src="assets/images/home-four/shape-2.webp" alt="" />
          </div>
          <div className="shape-3 absolute left-96 top-[550px] z-10">
            <img src="assets/images/home-four/shape-3.webp" alt="" />
          </div>
          <div className="shape-4 absolute right-96 top-[550px] z-10">
            <img src="assets/images/home-four/shape-4.webp" alt="" />
          </div>
        </div>
      </section>

    </>
  );
};

export default Career;
